import CompanySelect from "./company-select";

const CompanyFormItems = {
    Select: CompanySelect,
};

export default CompanyFormItems;